import { render } from "./gameReport.vue?vue&type=template&id=24b5eb8e&scoped=true"
import script from "./gameReport.vue?vue&type=script&lang=js"
export * from "./gameReport.vue?vue&type=script&lang=js"

import "./gameReport.vue?vue&type=style&index=0&id=24b5eb8e&lang=scss&scoped=true"
import "./gameReport.vue?vue&type=style&index=1&id=24b5eb8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5eb8e"]])

export default __exports__